/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { KeyLabelConfigOption } from './general.model';

export type MedicationConfig = Record<string, never>;

export type MedicationValue = {
  readonly key?: string;
  readonly dose?: Dose;
  readonly applicationMethod?: string;
  readonly source: MedicationSource;
  readonly customActiveSubstance?: string;
  readonly compound?: string;
};

export type Dose = {
  readonly unit: MedicationDoseUnit;
  readonly value: number;
};

export type Medication = {
  readonly key?: string;
  readonly activeSubstance: string;
  readonly favorite?: boolean;
  readonly tradeNames?: string[];
  readonly defaultUnit?: MedicationDoseUnit;
  readonly defaultApplicationMethod?: string;
  readonly compounds?: Compound[];
};

export type Compound = KeyLabelConfigOption & {
  readonly defaultApplicationMethod?: string;
};

export type ApplicationMethod = {
  readonly key: string;
  readonly methodName: string;
  readonly abbreviation: string;
};

export enum MedicationSource {
  CONFIGURATION = 'CONFIGURATION',
  CUSTOM = 'CUSTOM',
}

export type MedicationType = 'medication';

export enum MedicationDoseUnit {
  GRAM = 'GRAM',
  MILLIGRAM = 'MILLIGRAM',
  MILLILITER = 'MILLILITER',
  MICROGRAM = 'MICROGRAM',
  IU = 'IU',
}
